import React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import DayViewService from '../../services/userReport/DayViewService';
import { t } from 'i18next';
import { Column } from 'primereact/column';
import DivContainer from '../../components/DivContainer';
import { DataTable } from 'primereact/datatable';
import { Ripple } from 'primereact/ripple';
import { classNames } from 'primereact/utils';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputCalendarComponent from '../../components/inputs/InputCalendarComponent';
import { Button } from 'primereact/button';
import { CustomMessages } from '../../components/CustomMessages';
import BlockUi from '../../components/waitPanel/BlockUi';
import { Card } from 'primereact/card';
import PdfDownloadSpinner from '../../components/spinner/PdfDownloadSpinner';
import moment from 'moment';
import ProjectService from '../../services/ProjectService';
import { Inplace, InplaceDisplay, InplaceContent } from 'primereact/inplace';
import YesNoDialog from '../../components/YesNoDialog';
import SimpleReactValidator from '../../components/validator';
import { Prompt } from 'react-router-dom';
import UserRedirectWarningDialog from './UserRedirectWarningDialog';
import ActionLink from '../../components/ActionLink';
import AuthService from '../../services/AuthService';
import ActionButton from '../../components/ActionButton';
import SquareColorComponent from '../../components/inputs/SquareColorComponent';
import Constants from '../../utils/constants';

import { TabPanel, TabView } from 'primereact/tabview';
import LogEntryListContainer from '../LogEntryListContainer';
import ReportedUserDayService from '../../services/userReport/ReportedUserDayService';
import InputTextareaComponent from '../../components/inputs/InputTextareaComponent';


class DayViewContainer extends BaseListContainer {
    constructor(props) {
        super(props, new DayViewService());
        const queryParams = new URLSearchParams(this.props.history.location.search);
        const day = queryParams.get('day');
        let activeIndexParam = parseInt(queryParams.get('activeIndex'));
        this.state = {
            dateParamValue: day && moment(day, 'YYYY-MM-DD', true).isValid()  ? day : null,
            list: [],
            activities: {
                map: {}
            },
            addRowActivities: {
                map: {}
            },
            loading: true,
            size: 0,
            first: 0,
            legendVisible: false,
            criteria: this.getCleanSearchCriteria(),
            dialogVisibile: false,
            viewMode: 'VIEW',
            contractTypeForDay: undefined,
            element: {
                event: {
                    userTime: undefined,
                    timeFrom: undefined,
                    timeTo: undefined,
                    comment: undefined,
                    creativeTime: undefined
                }
            },
            activeFieldsModel: {
                map: {}
            },
            userDayId: undefined,
            dateParamValue: day ? day : null,
            approveDialogVisible: false,
            showConfirmDeleteActivityDialog: false,
            rowData: undefined,
            rowIndex: undefined,
            unlockDialogVisible: false,
            activeIndex: activeIndexParam ? activeIndexParam : 0
        };
        

        this.rowValidator = new SimpleReactValidator({}, this.translate);
        this.addRowValidator = new SimpleReactValidator({}, this.translate);
        this.userDayService = new ReportedUserDayService();
        this.authService = new AuthService()

        const getMinutes = (moment) => {
            const hours = moment.hours();
            const minutes = moment.minutes();
            return hours * 60 + minutes;
        }

        this.addRowValidator.addCustomRule('time_validation', t('userReporting.moreThanZeroValidaton'),
            (value, params) => {
                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    return this.state.element.event.userTime !== undefined && moment(this.state.element.event.userTime).format('HH:mm') !== '00:00'
                } else {
                    return this.state.element.event.timeFrom !== undefined
                        && this.state.element.event.timeTo !== undefined
                        && moment(this.state.element.event.timeFrom).format('HH:mm') !== '00:00'
                        && moment(this.state.element.event.timeTo).format('HH:mm') !== '00:00'
                }
            }, (message, value) => message, true
        );


        this.addRowValidator.addCustomRule('from_to_validation', t('userReporting.fromToValidation'),
            (value, params) => {
                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    return true;
                } else {
                    return this.state.element.event.timeFrom !== undefined
                        && this.state.element.event.timeTo !== undefined
                        && getMinutes(moment(this.state.element.event.timeFrom)) < getMinutes(moment(this.state.element.event.timeTo))
                }
            }, (message, value) => message, true
        );

        this.addRowValidator.addCustomRule('creative_time_validation', 'Czas pracy twórczej nie może przekraczać czasu pracy',
            (value, params) => {
                const userTime = this.state.element.event.userTime;
                const creativeTime = this.state.element.event.creativeTime;
                if (userTime && creativeTime) {
                    return getMinutes(moment(creativeTime)) <= getMinutes(moment(userTime))
                }else{
                    return true;
                }
            }, (message, value) => message, true
        );


        this.addRowValidator.addCustomRule('creative_time_at_least_one_minute',  'Należy wpisać czas pracy',
            (value, params) => {
                const userTime = this.state.element.event.userTime;
                const creativeTime = this.state.element.event.creativeTime;
                if (userTime && creativeTime) {
                    return  moment(this.state.element.event.userTime).format('HH:mm') !== '00:00' && moment(this.state.element.event.creativeTime).format('HH:mm') !== '00:00'
                }else{
                    return false;
                }
            }, (message, value) => message, true
        );

        this.addRowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
            (value, params) => {
                const { element } = this.state;
                let result = true;
                if (element.activity && element.activity.id
                    && element.project && element.project.id) {
                    this.state.list.forEach((x) => {
                        const projectId = x?.project?.id;
                        const activityId = x?.activity?.id;
                        if (element.project.id === projectId && activityId === element.activity.id
                            && !this.authService.getProfile().timeReportingStartEndDateRequired) {

                            result = false;
                        }
                    })
                }
                return result;
            }, (message, value) => message
        )

        this.rowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
            (value, params) => {
                const element = this.state.list[params[0]];
                let result = true;

                if (element?.activity && element?.activity.id
                    && element?.project && element?.project.id) {
                    this.state.list.forEach((x) => {
                        const projectId = x?.project?.id;
                        const activityId = x?.activity?.id;
                        if (x.event.id !== element.event.id
                            && element.project.id === projectId && activityId === element.activity.id
                            && !this.authService.getProfile().timeReportingStartEndDateRequired) {
                            result = false;
                        }
                    })
                }
                return result;
            }, (message, value) => message
        )
        this.rowValidator.addCustomRule('from_to_row_validation', t('userReporting.fromToValidation'),
            (value, params) => {
                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    return true;
                } else {
                    const index = params[0];
                    const from = this.state.list[index].event.timeFrom;
                    const to = this.state.list[index].event.timeTo;
                    return getMinutes(moment(from)) < getMinutes(moment(to))
                }
            }, (message, value) => message, true
        );


        this.rowValidator.addCustomRule('creative_time_validation', 'Czas pracy twórczej nie może przekraczać czasu pracy',
            (value, params) => {
                const index = params[0];
                const userTime = this.state.list[index]?.event?.userTime;
                const creativeTime = this.state.list[index]?.event?.creativeTime;

                if (userTime && creativeTime) {
                    return getMinutes(moment(creativeTime)) <= getMinutes(moment(userTime));
                }else{
                    return true;
                }
            }, (message, value) => message, true
        );

        this.rowValidator.addCustomRule('creative_time_at_least_one_minute',  'Należy wpisać czas pracy',
            (value, params) => {
                const index = params[0];
                const userTime = this.state.list[index].event.userTime;
                const creativeTime = this.state.list[index].event.creativeTime;
                if (userTime && creativeTime) {
                    return  moment(this.state.element.event.userTime).format('HH:mm') !== '00:00' && moment(this.state.element.event.creativeTime).format('HH:mm') !== '00:00'
                }else{
                    return false;
                }
            }, (message, value) => message, true
        );


        this.rowValidator.addCustomRule('more_than_zero_row', t('userReporting.moreThanZeroValidaton'),
            (value, params) => {
                const index = params[0];
                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    const userTime = this.state.list[index].event.userTime;
                    return userTime !== undefined && moment(userTime).format('HH:mm') !== '00:00'
                } else {
                    const from = this.state.list[index].event.timeFrom;
                    const to = this.state.list[index].event.timeTo;
                    return from !== undefined
                        && to !== undefined
                        && moment(from).isValid()
                        && moment(to).isValid()
                        && moment(from).format('HH:mm') !== '00:00'
                        && moment(to).format('HH:mm') !== '00:00'
                }
            }, (message, value) => message, true
        );

        this.dayViewService = new DayViewService();
        this.projectService = new ProjectService();
        this.authService = new AuthService();
        
        this.isEmptyList = this.isEmptyList.bind(this);
        this.handleAddNewActivity = this.handleAddNewActivity.bind(this);
        this.decreaseSelectedDay = this.decreaseSelectedDay.bind(this);
        this.increaseSelectedDay = this.increaseSelectedDay.bind(this);
        this.handleEditActivity=this.handleEditActivity.bind(this);
        this.isRowActive = this.isRowActive.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.loadActivitiesForRow = this.loadActivitiesForRow.bind(this);
        this.normalizeListAfterRowEdit = this.normalizeListAfterRowEdit.bind(this);

        this.showLegendDialog = this.showLegendDialog.bind(this)
    }

    componentDidMount() {
        super.componentDidMount();
        window.onbeforeunload = this.handleBeforeUnload; // handler do blokowania refresha lub przejscia na inny url
    }

    isStartEndDateRequired() {
        return this.authService.getProfile().timeReportingStartEndDateRequired
    }

    isDirty() {
        let atLeastOneFieldOpenFlag = false;
        const activeFields = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(activeFields)) {
            if (value) {
                atLeastOneFieldOpenFlag = true;
                break;
            }
        }

        return atLeastOneFieldOpenFlag
    }

    handleBeforeUnload(event) {
        if (this.isDirty()) { //jesli chociaz jedno pole jest otwarte to zablokuj 
            event.preventDefault();
            return '';
        } else { //else, nie blokuj 
            return;
        }
    }


    updateSearchCriteria(criteria) {
        return {
            selectedDay: criteria.selectedDay
        };
    }

    getCleanSearchCriteria() {
        return {
            selectedDay: this.state?.dateParamValue ? moment(this.state?.dateParamValue) : moment() //default today 
        };
    }


    createQueryString(queryObject = {}) {
        let queryString = Object.keys(queryObject)
            .filter((key) => queryObject[key] && !(Array.isArray(queryObject[key]) && !queryObject[key].length))
            .map((key) => {
                return Array.isArray(queryObject[key]) ? queryObject[key].map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&') : `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
            }).join('&');
        return queryString ? `?${queryString}` : "";
    };



    afterGetListError() {
        this.showErrorMessage(t('userReporting.listError'), 10000);
    }

    initializeFromBackend() {
        this.projectService
            .reportableProjects()
            .then(projects => this.setState({ projects: projects }))
            .catch(() => {
                this.showErrorMessage(t('userReporting.projectError'));
            });
    }

    getListTitle() {
        return '';
    }

    formattedTimeToMinutes(time) {
        const split = time.split(':');
        return (Number(split[0] * 60)) + Number(split[1])
    }

    getSummary(list) {
        const startEndRequired = this.isStartEndDateRequired()
        let mappedList = []
        if (startEndRequired) {
            mappedList = list.map((x) => {
                return this.formattedTimeToMinutes(moment(x.event.timeTo).format('HH:mm')) - this.formattedTimeToMinutes(moment(x.event.timeFrom).format('HH:mm'))
            })
        } else {
            mappedList = list.map((x) => this.formattedTimeToMinutes(moment(x.event.userTime).format('HH:mm')))
        }
        let totalMinutes = 0;
        for (let i = 0; i < mappedList.length; i++) {
            totalMinutes += mappedList[i];
        }

        let creativeTimeSummary = 0;
        let creativeTimeList = list.filter(x => x.event.creativeTime).map((x) => this.formattedTimeToMinutes(moment(x.event.creativeTime).format('HH:mm')))
        for (let i = 0; i < creativeTimeList.length; i++) {
            creativeTimeSummary += creativeTimeList[i];
        }

        return {
            totalMinutes: totalMinutes,
            creativeTimeSummary: creativeTimeSummary
        }
    }

    getList() {
        const { criteria } = this.state;
        const activeElement = document.activeElement;
        this.setState(
            {
                loading: true,
            },
            () => {
                this.service
                    .getList(criteria)
                    .then((data) => {
                        if (this._isMounted) {
                             this.setState(
                                {
                                    contractTypeForDay: data.contractTypeForDay,
                                    list: this.updateListElements(data.events),
                                    loading: false,
                                    summary: this.getSummary(data.events),
                                    size: data.events.length,
                                    userDayId: data.userDayId //id do LogEntryContainer
                                },
                                () => {
                                    this.onAfterGetList(data.events);
                                    this.setTimeout(() => activeElement?.focus(), 50);
                                }
                            );
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: [],
                                    loading: false,
                                    size: 0,
                                },
                                () => {
                                    this.afterGetListError();
                                }
                            );
                        }
                    });
            }
        )
    }


    fromToUserTimeTemplate(rowData, props) {
        // FROM - TO, 8 am - 2 pm.
        const rowIndex = props?.rowIndex;
        return (
            <div style={{ '--bs-gutter-x': '0.2rem', width: '120px' }} className='row'>
                <div className='col-sm'>
                    <InputCalendarComponent
                        id={`usertime-from-${rowIndex}`}
                        name={`timeFrom`}
                        value={this.state.element.event.timeFrom}
                        stateField={'element.event'}
                        onChange={this.handleChange}
                        viewMode={'NEW'}
                        showLabel={false}
                        insideTable
                        showTime
                        validator={this.validator}
                        dateFormatMoment='HH:mm'
                        className='user-reporting-time-style'
                        timeOnly
                        validateViewMode={false}
                        validators={'from_to_validation|time_validation'}
                        placeholder=''
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className='clock' />}
                        readOnlyInput={false}
                        label={t('userReporting.timeFrom')}
                        propCustomValue={true}
                        mask='99:99'
                        style={{
                            maxWidth: '60px',
                            width: '50px',
                            boxSizing: 'border-box',
                            position: 'static'
                        }}
                        customTimePicker={(e)=>{
                        }}
                        onInputClick={(id) => {
                            const input = document.getElementById(id)
                            input.focus();
                            input.setSelectionRange(0, 0);
                        }}
                        trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                    />
                </div>
                <div className='col-sm'>
                    <InputCalendarComponent
                        id={`usertime-to-${rowIndex}`}
                        name={`timeTo`}
                        value={this.state.element.event.timeTo}
                        stateField={'element.event'}
                        onChange={this.handleChange}
                        viewMode={'NEW'}
                        showLabel={false}
                        insideTable
                        showTime
                        validator={this.addRowValidator}
                        dateFormatMoment='HH:mm'
                        timeOnly
                        validateViewMode={false}
                        validators={'from_to_validation|time_validation'}
                        placeholder=''
                        className='user-reporting-time-style'
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className='clock' />}
                        readOnlyInput={false}
                        label={t('userReporting.timeTo')}
                        propCustomValue={true}
                        mask='99:99'
                        style={{
                            maxWidth: '60px',
                            width: '50px',
                            boxSizing: 'border-box',
                            position: 'static'
                        }}
                        customTimePicker={(e)=>{                                           
                        }}
                        onInputClick={(id) => {
                            const input = document.getElementById(id)
                            input.focus();
                            input.setSelectionRange(0, 0);
                        }}
                        trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                    />
                </div>
            </div>
        );
    }

    userTimeTemplate(rowData, props) {
        return (
            <div className='col-sm'>
                <InputCalendarComponent
                    id={'usertime-add-row'}
                    name={'userTime'}
                    value={this.state.element.event.userTime}
                    stateField={'element.event'}
                    onChange={this.handleChange}
                    viewMode={'NEW'}
                    label={t('userReporting.workTime')}
                    showLabel={false}
                    insideTable
                    showTime
                    className='user-reporting-time-style'
                    dateFormatMoment='HH:mm'
                    timeOnly
                    validateViewMode={false}
                    placeholder='HH:mm'
                    showSeconds={false}
                    showIcon={false}
                    validator={this.addRowValidator}
                    validators={'time_validation'}
                    icon={() => <i className='clock' />}
                    readOnlyInput={false}
                    mask='99:99'
                    propCustomValue={true}
                    style={{
                        width: '50px',
                        maxWidth: '50px'
                    }}
                    showOnFocus={false}
                    customTimePicker={(e)=>{        
                    }}
                    onInputClick={(id) => {
                        const input = document.getElementById(id)
                        input.focus();
                        input.setSelectionRange(0, 0);
                    }}
                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                />
            </div>
        );
    }

    creativeTimeTemplate(rowData, props) {
        return (
            <div className='col-sm'>
                <InputCalendarComponent
                    id={'creativeTime-add-row'}
                    name={'creativeTime'}
                    value={this.state.element?.event?.creativeTime}
                    stateField={'element.event'}
                    onChange={this.handleChange}
                    viewMode={'NEW'}
                    label={t('userReporting.creativeTime')}
                    showLabel={false}
                    insideTable
                    showTime
                    className='user-reporting-time-style'
                    dateFormatMoment='HH:mm'
                    timeOnly
                    placeholder='HH:mm'
                    validateViewMode={false}
                    showSeconds={false}
                    showIcon={false}
                    validator={this.addRowValidator}
                    validators={'creative_time_validation'}
                    icon={() => <i className='clock' />}
                    readOnlyInput={false}
                    mask='99:99'
                    propCustomValue={true}
                    style={{
                        width: '50px',
                        maxWidth: '50px'
                    }}
                    showOnFocus={false}
                    customTimePicker={(e)=>{
                    }}
                    onInputClick={(id) => {
                            const input = document.getElementById(id)
                            input.focus();
                            input.setSelectionRange(0, 0);
                    }}
                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                />
            </div>
        );
    }

    handleEditActivity(rowData, rowIndex) {
        if (this.rowValidator.allValid()) {

            let data = this.state.activeFieldsModel.map;
            this.closeOpenInplaceComponents(data, rowIndex);

            this.setState(
                {
                    loading: true,
                }, () => {
                    const setStateElement = {
                        loading: false,
                        activeFieldsModel: {
                            map: data
                        }
                    };
                    this.dayViewService
                        .update({//"usuniecie" pola client
                            project: rowData.project,
                            activity: rowData.activity,
                            event: rowData.event
                        }, this.state.criteria.selectedDay)
                        .then((x) => {
                            if (this._isMounted) {
                                this.setState(
                                    setStateElement,
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                                this.rowValidator.hideMessages()
                            }
                        }).catch((err) => {
                            if (this._isMounted) {
                                this.showErrorMessage(err.message);
                                this.setState(
                                    {
                                        loading: false
                                    },
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                                this.rowValidator.hideMessages()
                            }
                        })
                }
            );
        } else {
            this.rowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    handleAddNewActivity() {
        const newElement = this.state.element;
        if (this.addRowValidator.allValid()) {
            this.setState(
                {
                    loading: true,
                }, () => {
                    const setStateElement = {
                        loading: false,
                        element: {
                            event: {
                                userTime: undefined,
                                timeFrom: undefined,
                                timeTo: undefined,
                                comment: ''
                            }
                        }
                    }
                    this.dayViewService
                        .add(newElement, this.state.criteria.selectedDay)
                        .then((x) => {
                            if (this._isMounted) {
                                this.setState(
                                    setStateElement,
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                                this.addRowValidator.hideMessages()
                            }
                        }).catch((err) => {
                            if (this._isMounted) {
                                this.showErrorMessage(err.message);
                                this.setState(
                                    setStateElement,
                                    () => {
                                        this.refreshTable();
                                    }
                                );
                                this.addRowValidator.hideMessages()
                            }
                        })
                }
            );
        } else {
            this.addRowValidator.showMessages();
            this.forceUpdate();
        }
    }

    renderAddRow(isDisabled) {
        const startEndRequired = this.isStartEndDateRequired();
        const renderTime = startEndRequired ? this.fromToUserTimeTemplate() : this.userTimeTemplate();
        const { summary, list } = this.state;
        const formattedSummary = this.formatTime(summary?.totalMinutes);
        const formattedCreativeTimeSummary = this.formatTime(summary?.creativeTimeSummary);
        const creativeTimeColumnRequired = this.isCreativeTimeColumnRequired();

        return (
            <ColumnGroup>
                {list.length >= 1 && (
                    <Row>
                        <Column footer="Podsumowanie" footerStyle={{ textAlign: "right" }} />
                        <Column footer="" colSpan={3} footerStyle={{ textAlign: "right" }} />
                        <Column
                            style={{ whiteSpace: "nowrap" }}
                            footer={
                                summary?.totalMinutes
                                    ? `${formattedSummary} / 8h`
                                    : "00:00 / 8h"
                            }
                            footerStyle={{ textAlign: "left" }}
                        />
                        {creativeTimeColumnRequired && (
                            <Column
                                style={{ whiteSpace: "nowrap" }}
                                footer={
                                    summary?.creativeTimeSummary
                                        ? `${formattedCreativeTimeSummary} / 8h`
                                        : "00:00 / 8h"
                                }
                                footerStyle={{ textAlign: "left" }}
                            />
                        )}
                        <Column />
                    </Row>
                )}
                {list.length === 0 ?
                 <Row>
                    <Column footer="Brak danych do wyświetlenia - Dodaj nowy wpis" colSpan={6} footerStyle={{ textAlign: "center", backgroundColor: '#f4f5fc' }} />
                </Row>
                :
                <Row>
                    <Column footer="" colSpan={creativeTimeColumnRequired ? 7 : 6} footerStyle={{ textAlign: "right", backgroundColor: '#f4f5fc' }} />
                    {/* 7 kolumn jesli jest praca tworcza, domyslnie 6 */}
                </Row>
                }

                {!isDisabled && (
                    <Row>
                        <Column
                            style={{ position: "static" }}
                            footer={() => (
                                <InputDropdownComponent
                                    id="client-row"
                                    name="client"
                                    value={this.state.element?.project?.client}
                                    validator={this.addRowValidator}
                                    options={this.state.projects}
                                    onChange={this.handleChange}
                                    viewMode="VIEW"
                                    optionLabel="name"
                                    dataKey="id"
                                    validators="required|record_already_assigned"
                                    label={t("userReporting.project")}
                                    showLabel={false}
                                    placeholder={t("userReporting.project")}
                                    filter
                                    filterBy="name"
                                    className="custom-dropdown"
                                    insideTable
                                    style={{
                                        height: "35px",
                                        boxSizing: "border-box",
                                    }}
                                />
                            )}
                        />
                        <Column
                            style={{
                                width: "600px",
                                maxWidth: "600px",
                                position: "static",
                            }}
                            footer={() => (
                                <InputDropdownComponent
                                    id="project-row"
                                    name="project"
                                    value={this.state.element?.project}
                                    validator={this.addRowValidator}
                                    options={this.state.projects}
                                    onChange={this.handleChange}
                                    viewMode="NEW"
                                    optionLabel="name"
                                    dataKey="id"
                                    validators="required|record_already_assigned"
                                    label={t("userReporting.project")}
                                    showLabel={false}
                                    placeholder={t("userReporting.project")}
                                    filter
                                    filterBy="name"
                                    className="custom-dropdown"
                                    insideTable
                                    style={{
                                        height: "35px",
                                        maxWidth: "100%",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                    onAfterStateChange={(e) => {
                                        this.projectService
                                            .getTimeReportingActivities(this.state.element?.project?.id)
                                            .then((activities) => {
                                                if (
                                                    !activities
                                                        .map((x) => x?.id)
                                                        .includes(
                                                            this.state.element.activity?.id
                                                        )
                                                ) {
                                                    this.state.element.activity = null;
                                                }
                                                this.setState({
                                                    addRowActivities: {
                                                        map: activities,
                                                    },
                                                });
                                            })
                                            .catch(() => {
                                                this.setState({
                                                    addRowActivities: {
                                                        map: {},
                                                    },
                                                });
                                                this.showErrorMessage(
                                                    t("userReporting.activityError")
                                                );
                                            });
                                    }}
                                />
                            )}
                        />
                        <Column
                            style={{ position: "static" }}
                            footer={() => (
                                <InputDropdownComponent
                                    id="activity"
                                    name="activity"
                                    value={this.state.element?.activity}
                                    colClass="col-xl-12 col-lg-12 col-md-12 col-sm-12"
                                    options={this.state.addRowActivities.map}
                                    label={t("userReporting.activity")}
                                    showLabel={false}
                                    onChange={this.handleChange}
                                    viewMode="NEW"
                                    optionLabel="name"
                                    dataKey="id"
                                    className="custom-dropdown"
                                    validator={
                                        this.state.element.project === undefined
                                            ? null
                                            : this.addRowValidator
                                    }
                                    validators="required|record_already_assigned"
                                    placeholder={t("userReporting.activity")}
                                    filter
                                    filterBy="name"
                                    insideTable
                                    disabled={
                                        this.state.element.project === undefined
                                    }
                                    style={{
                                        height: "35px",
                                        maxWidth: "100%",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                />
                            )}
                        />
                        <Column
                            style={{ position: "static" }}
                            footer={() => (
                                    <InputTextareaComponent
                                        id="comment-sc"
                                        className="custom-text-area"
                                        name="comment"
                                        colClass="col-xl-12 col-lg-12 col-md-12 col-sm-12"
                                        value={this.state.element.event?.comment}
                                        stateField="element.event"
                                        onChange={this.handleChange}
                                        viewMode="NEW"
                                        maxlength={500}
                                        global
                                        refreshFromBackend
                                        timeoutHandler={this.refreshTable}
                                        autoResize
                                    />
                            )}
                        />
                        <Column
                            footer={() => (
                                <div>
                                    {renderTime}
                                    <div
                                        style={{
                                            position: "absolute",
                                            marginTop: "3px",
                                        }}
                                    >
                                        <span>
                                            {this.addRowValidator.message(
                                                "",
                                                "",
                                                "",
                                                "time_validation|from_to_validation|creative_time_validation"
                                            )}
                                        </span>
                                    </div>
                                </div>
                            )}
                        />
                        {creativeTimeColumnRequired && (
                            <Column
                                footer={() => (
                                    <div>
                                        {this.creativeTimeTemplate()}
                                        <div
                                            style={{
                                                position: "absolute",
                                                marginTop: "3px",
                                            }}
                                        />
                                    </div>
                                )}
                            />
                        )}
                        <Column
                            footer={() => (
                                <div
                                    id='addRowButton'
                                    style={{
                                        minHeight: "40px",
                                        height: "40px",
                                    }}
                                >
                                    <ActionButton
                                        label="Zapisz"
                                        handleClick={this.handleAddNewActivity.bind(this)}
                                        style={{ width: "fit-content" }}
                                    />
                                </div>
                            )}
                        />
                    </Row>
                )}
            </ColumnGroup>
        );
    }

    footerGroup() {
        let isDisabled = this.state.list.length > 0 &&
        this.state.list.filter((x) => x.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || x.event.acceptLevel === Constants.PM_APPROVED_LEVEL).length === this.state.list.length;
        //return //isDisabled === true ? null :
        return this.renderAddRow(isDisabled);
    }

    generateCustomFooterIfPossible() {
        return this.footerGroup()
    }

    isEmptyList() {
        return this.state.list.length === 0;
    }

    onToggleFunction(rowIndex, columnIndex, activeFieldsModel) {
        let data = activeFieldsModel.map;
        if (data[[rowIndex, columnIndex]] === undefined || data[[rowIndex, columnIndex]] === false) {
            data[[rowIndex, columnIndex]] = true;
            this.setState({
                activeFieldsModel: {
                    map: data
                }
            })
        }
    }
    getIsActive(rowIndex, columnIndex, activeFieldsModel) {
        return (activeFieldsModel?.map[[rowIndex, columnIndex]]) ? true : false;
    }


    legendDescription() {
        let legend = (
            <>

                <div id='accepted-by-user-legend' style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'flex-end',
                    gap: '20px',
                }}>
                    <SquareColorComponent value='#d4fae0' />
                    <span className='p-disabled'> Aktywność zaakceptowana przez użytkownika</span>
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'start',
                    marginTop: '2%',
                    gap: '20px',
                    alignItems: 'flex-end' 
                }}>
                    <SquareColorComponent value='#89faad' />
                    <span className='p-disabled'>Aktywność zaakceptowana przez PM</span>
                </div>
            </>
        );
        return legend;
    }


   showLegendDialog() {
        this.setState({
            legendVisible: true
        })
    }


    renderDataTable(columns, list, size) {
        const {criteria, first, loading} = this.state;
        if (list === null || list === undefined) {
            list = this.props.list ? this.props.list : this.state.list;
        }
        if (size === null || size === undefined) {
            size = this.props.list ? this.props.size : this.state.size;
        }
        const dynamicColumns = columns.map((col,index) => {
            return (
                <Column
                    selectionMode={col.selectionMode}
                    key={col.key ? col.key : col.field}
                    field={col.field}
                    filter
                    filterField={col.field}
                    showFilterMenu={false}
                    header={col.header}
                    body={col.body}
                    bodyClassName={col.bodyClassName}
                    headerClassName={col.headerClassName}
                    className={col.className}
                    sortable={col.sortable}
                    sortField={col.sortField !== undefined ? col.sortField : col.field}
                    style={col.width !== undefined ? {width: col.width, maxWidth: col.width} : null}
                    columnIndex={index}
                    height={col.height}
                />
            );
        });
        const isPm = this.authService.isUserInAnyRoleArray(['ROLE_TIMESHEET_APPROVE'])

        const rowsPerPageOptions = [5, 10, 20, 50, 100];
        const isEmpty = this.isEmptyList();

        let recordToUnlockExists = false
        let isAllApproved = false;

        if (isPm) {
            recordToUnlockExists = this.state.list.filter(x=>x.event.acceptLevel !== Constants.TO_APPROVE_BY_USER_LEVEL).length > 0;
            isAllApproved = this.state.list.filter(x => x.event.acceptLevel === Constants.PM_APPROVED_LEVEL).length === this.state.list.length
        } else {
            recordToUnlockExists = this.state.list.filter(x => x.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL).length > 0 && this.state.list.filter(x => x.event.acceptLevel === Constants.PM_APPROVED_LEVEL).length !== this.state.list.length
            isAllApproved = this.state.list.filter(x => x.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || x.event.acceptLevel === Constants.PM_APPROVED_LEVEL).length === this.state.list.length
        }

        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <div className=''>
                        <DataTable
                            id='dataTable'
                            key='data-table'
                            unstyled={true}
                            emptyMessage={t('list.empty')}
                            className={isEmpty ? 'empty-table' : 'fixed-datatable'}
                            breakpoint='10px'
                            value={list}
                            paginator={false}
                            footerColumnGroup={this.generateCustomFooterIfPossible()}
                            globalFilterFields={this.globalFilterFields()}
                            filters={this.state.filters}
                            rows={criteria.maxResults}
                            totalRecords={size}
                            first={first}
                            footer={(e) => {
                                {
                                    return isEmpty ? null :
                                        (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'end',
                                                    gap: '10px'
                                                }}
                                            > 
                                                <div
                                                    style={{
                                                        marginRight: 'auto'
                                                    }}
                                                >
                                                     {this.legendDescription()}
                                                </div>
                                                <div>

                                                </div>
                                                {this.state.activeIndex === 1 ? null :
                                                    (<>
                                                        {!isAllApproved && !this.isDirty() ?
                                                            (
                                                                <ActionButton
                                                                    id='accept-button'
                                                                    label={t('userReporting.confirm')}
                                                                    className="float-right header-item"
                                                                    handleClick={(e) => {
                                                                        this.setState({
                                                                            approveDialogVisible: true
                                                                        })
                                                                    }}
                                                                />

                                                            )
                                                            :
                                                            null}
                                                        {recordToUnlockExists && !this.isDirty() ?
                                                            <ActionButton
                                                                label={t('userReporting.unlock')}
                                                                className={`float-right header-item`}
                                                                handleClick={(e) => {
                                                                    this.setState({
                                                                        unlockDialogVisible: true
                                                                    })
                                                                }}
                                                            />
                                                            :
                                                            null
                                                        }
                                                    </>
                                                    )
                                                }
                                            </div>
                                        )
                                }
                            }}
                            rowClassName={(rowData, obj) => {
                                // const status = rowData.event.status.enumValue;
                                const acceptLevel = rowData.event.acceptLevel
                                const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL && acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL
                                const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                                return isUserApproved ? {
                                    'user-approved-row': true
                                } : (isPmApproved ? {
                                    'pm-approved-row': true
                                } : null)
                            }}
                            rowsPerPageOptions={rowsPerPageOptions}
                            sortField={criteria.sortField}
                            sortOrder={criteria.sortAsc ? 1 : -1}
                            loading={loading}
                            paginatorPosition='bottom'
                            currentPageReportTemplate={
                                size !== 0
                                    ? `Pozycje od ${first + 1} do ${
                                          first + criteria.maxResults > size ? size : first + criteria.maxResults
                                      } z ${size} łącznie`
                                    : '0 pozycji'
                            }
                            paginatorTemplate={{
                                layout: 'RowsPerPageDropdown PrevPageLink PageLinks NextPageLink CurrentPageReport',
                                PrevPageLink: (options) => {
                                    if (criteria.firstResult === 0) {
                                        return null;
                                    } else {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={options.onClick}
                                                disabled={options.disabled}
                                            >
                                                <span className='p-paginator-icon pi pi-angle-left'></span>
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                                NextPageLink: (options) => {
                                    if (criteria.firstResult + criteria.maxResults >= size) {
                                        return null;
                                    } else {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={options.onClick}
                                                disabled={options.disabled}
                                            >
                                                <span className='p-paginator-icon pi pi-angle-right'></span>
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                                RowsPerPageDropdown: (options) => {
                                    return this.renderPagination(rowsPerPageOptions, options);
                                },
                                CurrentPageReport: (options) => {
                                    return <div className='p-paginator-dummy' />;
                                },
                                PageLinks: (options) => {
                                    if (options.view.startPage === options.page && options.view.startPage !== 0) {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={() => {
                                                    this.handlePage({first: 0, rows: this.state.criteria.maxResults});
                                                }}
                                            >
                                                {1}
                                                <Ripple />
                                            </button>
                                        );
                                    } else if (options.view.endPage === options.page && options.view.endPage !== options.totalPages - 1) {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={() => {
                                                    this.handlePage({
                                                        first: (options.totalPages - 1) * this.state.criteria.maxResults,
                                                        rows: this.state.criteria.maxResults,
                                                    });
                                                }}
                                            >
                                                {options.totalPages}
                                                <Ripple />
                                            </button>
                                        );
                                    } else if (
                                        (options.view.startPage + 1 === options.page && options.view.startPage !== 0) ||
                                        (options.view.endPage - 1 === options.page &&
                                            options.view.endPage !== options.totalPages - 1 &&
                                            options.page !== options.totalPages - 1)
                                    ) {
                                        const className = classNames(options.className, {'p-disabled': true});
                                        return (
                                            <span className={className} style={{userSelect: 'none'}}>
                                                ...
                                            </span>
                                        );
                                    } else {
                                        return (
                                            <button type='button' className={options.className} onClick={options.onClick}>
                                                {options.page + 1}
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                            }}
                            pageLinkSize={this.getPageLinkSize()}
                            lazy={this.props.lazy}
                            onPage={this.handlePage}
                            onSort={this.handleSort}
                            selectionMode={'checkbox'}
                            onSelectionChange={this.handleOnSelectionChange}
                            selection={this.state.selectedList}
                            selectAll={this.state.selectAll}
                            onSelectAllChange={this.handleOnSelectAllChange}
                            dataKey={this.dataKey}
                            expandedRows={this.state.expandedRows}
                            onRowToggle={this.handleOnRowToggle}
                            onRowExpand={this.handleOnRowExpand}
                            onRowCollapse={this.handleOnRowCollapse}
                            rowExpansionTemplate={this.rowExpansionTemplate}
                            selectionPageOnly={false}
                            style={{
                                minWidth: '700px'
                            }}
                            tableStyle={{
                                'table-layout': 'fixed'
                            }}
                        >
                            {this.props.rowExpansionTemplate ? <Column expander headerStyle={{width: '3em'}}></Column> : null}
                            {this.props.disableSelection === true || !this.props.selectionMode ? null : (
                                <Column selectionMode={this.props.selectionMode} headerStyle={{width: '3em'}}></Column>
                            )}
                            {dynamicColumns}
                        </DataTable>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }

    enumTemplate(field, rowData) {
        if (rowData[field] && rowData[field].label) {
            return rowData[field].label;
        } else if (rowData[field]) {
            return rowData[field];
        }
        return '';
    }


    actionTemplate() {
        return (
            <Button
                icon="pi pi-plus"
                onClick={this.handleAddNewActivity}
                variant='blue'
                className='addRowButton'
                style={{
                    width: '80px',
                    height: '50px'
                }}
                key={'view-button'}
                rendered={true}
            />
        );
    }

    getClientColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;
        const { activeFieldsModel } = this.state;
        const isDisabled = rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL;
        return (
            isDisabled ?
            <>
                  <td id={`project-display-${rowIndex}`} style={{
                            backgroundColor: 'inherit',
                            color:'#5d5e5e'
                        }}>
                            <span
                                style={{
                                    overflowWrap: 'break-word',
                                    minWidth: '100%',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word'
                                }}>{`${rowData?.client.name}`}</span>
                        </td>
            </> :
            <div>
                <Inplace
                    active={this.getIsActive(rowIndex, columnIndex, activeFieldsModel)}
                    onToggle={(e) => {
                        this.onToggleFunction(rowIndex, columnIndex, activeFieldsModel)
                    }}
                    disabled={true}
                    className={rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL ? '' : 'non-grayed-column'} //jesli event zaakceptowany to wyszarz tekst
                >
                    <InplaceDisplay >
                        <td id={`project-display-${rowIndex}`} style={{
                            backgroundColor: 'inherit'
                        }}>
                            <span
                                style={{
                                    overflowWrap: 'break-word',
                                    minWidth: '100%',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word'
                                }}>{`${rowData?.client.name}`}</span>
                        </td>
                    </InplaceDisplay>
                    <InplaceContent>
                        <td id={`project-content-${rowIndex}`} style={{
                            backgroundColor: 'inherit'
                        }}>
                            <span
                                style={{
                                    overflowWrap: 'break-word',
                                    minWidth: '100%',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word',
                                }}>{`${rowData?.client.name}`}</span>
                        </td>
                    </InplaceContent>
                </Inplace>
            </div>
        );
    }


    getProjectColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;
        const { activeFieldsModel } = this.state;
        const isDisabled = rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL;
        return (
            isDisabled ?
            <>
               <td id={`project-span-${rowIndex}`} style={{
                            backgroundColor: 'inherit',
                            color:'#5d5e5e'
                        }}>
                            <span
                                style={{
                                    overflowWrap: 'break-word',
                                    minWidth: '100%',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word',
                                }}>{`${rowData?.project.name}`}</span>
                        </td>
            </>
            :
            <div>
                <Inplace
                    active={this.getIsActive(rowIndex, columnIndex, activeFieldsModel)}
                    onToggle={(e) => {
                        this.onToggleFunction(rowIndex, columnIndex, activeFieldsModel)
                    }}
                    disabled={rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL}
                >
                    <InplaceDisplay >
                        <td id={`project-span-${rowIndex}`} style={{
                            backgroundColor: 'inherit'
                        }}>
                            <span
                                style={{
                                    overflowWrap: 'break-word',
                                    minWidth: '100%',
                                    whiteSpace: 'normal',
                                    wordWrap: 'break-word',
                                    wordBreak: 'break-word',
                                }}>{`${rowData?.project.name}`}</span>
                        </td>
                    </InplaceDisplay>
                    <InplaceContent>
                        <InputDropdownComponent
                            id={`project-input-${rowIndex}`}
                            name='project'
                            colClass='col-md-7'
                            value={rowData?.project}
                            className='custom-dropdown'
                            options={this.state.projects}
                            stateField={`list[${rowIndex}]`}
                            onAfterStateChange={() => {
                                this.projectService
                                    .getTimeReportingActivities(rowData.project.id)
                                    .then(activities => {
                                        let activeFields = this.state.activeFieldsModel.map;
                                        if (!activities.map((x) => x?.id).includes(rowData.activity?.id)) {
                                            //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                                            rowData.activity = null
                                            const activityColumnIndex = 2;
                                            activeFields[[rowIndex, activityColumnIndex]] = true; //usuwana jest aktywnosc ktorej nie ma w projekcie, 
                                            //user musi ustawic aktywnosc z projektu, pole zostaje "otwarte" do edycji
                                        }
                                        const data = this.state.activities.map;
                                        data[rowIndex] = activities;
                                        this.setState((prev) => (({
                                            activeFieldsModel: {
                                                map: activeFields
                                            },
                                            activities: {
                                                map: data
                                            }
                                        })))
                                    }).catch(() => {
                                        this.setState({
                                            activities: {
                                                map: {}
                                            }
                                        })
                                        this.showErrorMessage(t('userReporting.activityError'));
                                    })
                            }}
                            onChange={this.handleChange}
                            style={{
                                height: '35px',
                                maxWidth: '100%',
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                            viewMode={'NEW'}
                            optionLabel='name'
                            dataKey='id'
                            validator={this.rowValidator}
                            validators={`required|record_already_assigned:${rowIndex}`}
                            placeholder={t('userReporting.project')}
                            filter
                            filterBy='name'
                            insideTable
                        />
                    </InplaceContent>
                </Inplace>
            </div>
        );
    }

    loadActivitiesForRow(rowData, rowIndex) {
        this.projectService
            .getTimeReportingActivities(rowData.project.id)
            .then(activities => {
                if (!activities.map((x) => x?.id).includes(rowData.activity?.id)) {
                    //usun aktywnosc jesli nie jest przypisana do wybranego projektu
                    rowData.activity = null
                }
                const data = this.state.activities.map;
                data[rowIndex] = activities;
                this.setState(({
                    activities: {
                        map: data
                    }
                }))
            }).catch(() => {
                this.setState({
                    activities: {
                        map: {}
                    }
                })
                this.showErrorMessage(t('userReporting.activityError'));
            })
    }
    getActivityColumn(rowData, prop) {        
        const {activeFieldsModel}=this.state;
        const { rowIndex } = prop;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;
        const isDisabled = rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL;
        return (
            isDisabled ?
                <>
                    <td style={{
                        backgroundColor: 'inherit',
                        maxWidth: '100%',
                        width: '100%',
                        boxSizing: 'border-box',
                        color:'#5d5e5e'
                    }}>
                        <span className=''>
                            {rowData?.activity?.name ? `${rowData?.activity?.name}` : ''}
                        </span>
                    </td>
                </>
            :
            <Inplace
                active={this.getIsActive(rowIndex, columnIndex, activeFieldsModel)}
                onToggle={(e) => {
                    if (this.state.activities.map[rowIndex] === undefined) {
                        this.loadActivitiesForRow(rowData, rowIndex)
                    }
                    this.onToggleFunction(rowIndex, columnIndex, activeFieldsModel)
                }}
                >
                <InplaceDisplay>
                    <td style={{
                        backgroundColor: 'inherit',
                        maxWidth: '100%',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        <span className=''>
                            {rowData?.activity?.name ? `${rowData?.activity?.name}` : ''}
                        </span>
                    </td>
                </InplaceDisplay>
                <InplaceContent>
                    <div>
                        <InputDropdownComponent
                            id='activity-input'
                            name='activity'
                            colClass='col-lg-2 col-sm-2 col-md-2'
                            value={rowData?.activity}
                            validator={this.rowValidator}
                            validators={`required|record_already_assigned:${rowIndex}`}
                            label={t('userReporting.activity')}
                            stateField={`list[${rowIndex}]`}
                            showLabel={false}
                            options={this.state.activities.map[rowIndex]} //aktywnosci przypisane do projektu
                            onChange={this.handleChange}
                            style={{
                                height: '35px',
                                maxWidth: '100%',
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                            className='custom-dropdown'
                            viewMode={'NEW'}
                            optionLabel='name'
                            dataKey='id'
                            labe={t('userReporting.activity')}
                            placeholder={t('userReporting.activity')}
                            filter
                            filterBy='name'
                            insideTable
                        />
                    </div>
                </InplaceContent>
            </Inplace>
        );
    }

    getCommentColumn(rowData, prop){
        const {activeFieldsModel}=this.state;
        const { rowIndex } = prop;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;

        const isDisabled= rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL;
        return (
            isDisabled ?
            <>
                    <td style={{
                        backgroundColor: 'inherit',
                        width: '190%',
                        boxSizing: 'border-box',
                        color: '#5d5e5e'
                    }}>
                        <InputTextareaComponent
                            id='comment-sc'
                            name='comment'
                            value={rowData.event.comment}
                            stateField={`list[${rowIndex}].event`}
                            onChange={this.handleChange}
                            maxlength={500}
                            viewMode='VIEW'
                            global={true}
                            viewStyle={{
                                color: '#5d5e5e',
                                wordBreak: 'break-word',
                            }}
                            refreshFromBackend
                            timeoutHandler={this.refreshTable}
                            insideTable
                            autoResize
                        />
                    </td>
            </> :
            <Inplace
                active={this.getIsActive(rowIndex, columnIndex, activeFieldsModel)}
                onToggle={(e) => {
                    this.onToggleFunction(rowIndex, columnIndex, activeFieldsModel)
                }}
                >
                <InplaceDisplay

                    >
                    <td style={{
                        backgroundColor: 'inherit',
                        width: '100%',
                        boxSizing: 'border-box',
                        height: '100%',
                    }}>
                    <InputTextareaComponent
                        id='comment-sc'
                        name='comment'
                        value={rowData.event.comment}
                        stateField={`list[${rowIndex}].event`}
                        onChange={this.handleChange}
                        maxlength={500}
                        viewMode='VIEW'
                        global={true}
                        refreshFromBackend
                        timeoutHandler={this.refreshTable}
                        insideTable
                        autoResize
                        viewStyle={{
                         minHeight: '19px',
                         minWidth: '80px',
                         width: 'fit-content',
                         maxWidth: '100%',
                         wordBreak: 'break-word'
                        }}
                    />
                    </td>
                </InplaceDisplay>
                <InplaceContent>
                    <InputTextareaComponent
                        id='comment-sc'
                        name='comment'
                        value={rowData.event.comment}
                        stateField={`list[${rowIndex}].event`}
                        onChange={this.handleChange}
                        maxlength={500}
                        viewMode='NEW'
                        global={true}
                        refreshFromBackend
                        timeoutHandler={this.refreshTable}
                        insideTable
                        autoResize
                    />
                </InplaceContent>
            </Inplace>
        );
    }

    getMinutes(date){
        const hours = moment(date).hours();
        const minutes = moment(date).minutes();
        return moment(new Date()).format('YYYY-MM-DD') + ' ' + hours + ':' + minutes;
    }

    normalizeListAfterRowEdit(list){
        //moze byc case ze user zedytuje kilka pol w kilku wierszach
        // i bedzie kazdy wiersz po kolei zapisywac 
        // przy zapisie edycji jest refresh listy wiec juz po jednym zapisie wszystkim polom przypisana zostanie wartosc z bazy 
        // i user bedzie musial od nowa edytowac.
        let rowsToIgnore = []
        const data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (value) { //jesli dla danej kolumny jest ustawione true
                rowsToIgnore.push(
                    arr[0] //dodaj, ktory wiersz nalezy "zignorowac"
                );
            }
        }
        const currentList = this.state.list; //obecne wartosci z listy
        return list.map((valueFromDb, index) => 
            rowsToIgnore.includes(index) ? currentList[index] : valueFromDb
            //jesli indeks matchuje sie z wierszem do "zignorowania", ustaw wartosc ze state else wez zaktualizowana wartosc
        );
        //wtedy po zapisie user zachowa zmiany w innych edytowanych wierszach
    }


    updateListElements(list) {
        list.forEach((x) => {
            x.event.timeFrom = x.event.timeFrom ? moment(x.event.timeFrom).toDate() : null;
            x.event.timeTo = x.event.timeTo ? moment(x.event.timeTo).toDate() : null;
        });
        return this.normalizeListAfterRowEdit(list);
    }

    getUserTimeColumn(rowData, prop) {
        const { activeFieldsModel } = this.state;
        const { rowIndex } = prop;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;
        
        rowData.event.userTime = rowData.event.userTime ? moment(rowData.event.userTime).toDate() : null;
        rowData.event.timeFrom = rowData.event.timeFrom ? moment(rowData.event.timeFrom).toDate() : null;
        rowData.event.timeTo = rowData.event.timeTo ? moment(rowData.event.timeTo).toDate() : null;

        const startEndRequired = this.isStartEndDateRequired();
        const width = startEndRequired ? '120px' : '70px';

        let formattedUserTime = '';
        if (startEndRequired) {
            formattedUserTime = rowData.event.timeFrom && rowData.event.timeTo ? `${moment(rowData.event.timeFrom).format('H:mm')}-${moment(rowData.event.timeTo).format('H:mm')}` : ``;
        } else {
            formattedUserTime = moment(rowData.event.userTime).format('HH:mm');
        }
        const isDisabled = rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL;
        return (
            isDisabled ?
                <>
                    <td style={{
                        backgroundColor: 'inherit',
                        color:'#5d5e5e'
                    }}>
                        <span>
                            {formattedUserTime}
                        </span>
                    </td>
                </>
            :
            <>
            <div>
                <Inplace
                    active={this.getIsActive(rowIndex, columnIndex, activeFieldsModel)}
                    onToggle={(e) => {
                        this.onToggleFunction(rowIndex, columnIndex, activeFieldsModel);
                    }}
                >
                    <InplaceDisplay>
                        <td style={{
                            backgroundColor: 'inherit'
                        }}>
                            <span>
                                {formattedUserTime}
                            </span>
                        </td>

                    </InplaceDisplay>
                    <InplaceContent>
                        <div style={{ display: 'flex', justifyContent: 'start', padding: 0, width: '65px', maxWidth: '65px' }}>
                            {!startEndRequired ? (
                                <InputCalendarComponent
                                    id={`usertime-content-${rowIndex}`}
                                    name={'userTime'}
                                    value={rowData.event.userTime}
                                    stateField={`list[${rowIndex}].event`}
                                    onChange={this.handleChange}
                                    viewMode={'NEW'}
                                    showLabel={false}
                                    insideTable
                                    showTime
                                    validator={this.rowValidator}
                                    validators={`more_than_zero:${rowIndex}`}
                                    label={t('userReporting.workTime')}
                                    dateFormatMoment='HH:mm'
                                    className='user-reporting-time-style'
                                    timeOnly
                                    validateViewMode={true}
                                    placeholder=''
                                    showSeconds={false}
                                    showIcon={false}
                                    icon={() => <i className='clock' />}
                                    readOnlyInput={false}
                                    propCustomValue={true}
                                    mask='99:99'
                                    style={{
                                        maxWidth: '50px',
                                        width: '60px',
                                        boxSizing: 'border-box'
                                    }}
                                    showOnFocus={false}
                                    customTimePicker={(e) => {
                                    }}
                                    onInputClick={(id) => {
                                        const input = document.getElementById(id)
                                        input.focus();
                                        input.setSelectionRange(0, 0);
                                    }}
                                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                />
                            ) : (
                                    <div style={{ minWidth: width, '--bs-gutter-x': '0.2rem' }} className='row'>
                                        <div className='col'>
                                            <InputCalendarComponent
                                                id={`time-from-input-inside-list-${rowIndex}`}
                                                name={`timeFrom`}
                                                value={rowData.event.timeFrom}
                                                stateField={`list[${rowIndex}].event`}
                                                onChange={this.handleChange}
                                                viewMode={'NEW'}
                                                showLabel={false}
                                                insideTable
                                                showTime
                                                validator={this.rowValidator}
                                                validators={`more_than_zero_row:${rowIndex}|from_to_row_validation:${rowIndex}`}
                                                validateViewMode={rowData.event.timeTo ? true : false}
                                                label={t('userReporting.workTime')}
                                                dateFormatMoment='HH:mm'
                                                className='user-reporting-time-style'
                                                timeOnly
                                                placeholder=''
                                                showSeconds={false}
                                                showIcon={false}
                                                icon={() => <i className='clock' />}
                                                readOnlyInput={false}
                                                propCustomValue={true}
                                                mask='99:99'
                                                style={{
                                                    maxWidth: '50px',
                                                    width: '60px',
                                                    boxSizing: 'border-box'
                                                }}
                                                showOnFocus={false}
                                                customTimePicker={(e) => {
                                                }}
                                                onInputClick={(id) => {
                                                    const input = document.getElementById(id)
                                                    input.focus();
                                                    input.setSelectionRange(0, 0);
                                                }}
                                                trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                            />
                                        </div>
                                        <div className='col'>
                                            <InputCalendarComponent
                                                id={`time-to-input-inside-list-${rowIndex}`}
                                                name={`timeTo`}
                                                value={rowData.event.timeTo}
                                                stateField={`list[${rowIndex}].event`}
                                                onChange={this.handleChange}
                                                viewMode={'NEW'}
                                                showLabel={false}
                                                insideTable
                                                className='user-reporting-time-style'
                                                showTime
                                                validator={this.rowValidator}
                                                validators={`more_than_zero_row:${rowIndex}|from_to_row_validation:${rowIndex}`}
                                                dateFormatMoment='HH:mm'
                                                timeOnly
                                                validateViewMode={rowData.event.timeFrom ? true : false}
                                                placeholder=''
                                                mask='99:99'
                                                showSeconds={false}
                                                showIcon={false}
                                                icon={() => <i className='clock' />}
                                                readOnlyInput={false}
                                                propCustomValue={true}
                                                style={{
                                                    maxWidth: '50px',
                                                    width: '60px',
                                                }}
                                                customTimePicker={(e) => {
                                                }}
                                                onInputClick={(id) => {
                                                    const input = document.getElementById(id)
                                                    input.focus();
                                                    input.setSelectionRange(0, 0);
                                                }}
                                                trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                            />
                                        </div>
                                    </div>
                            )}
                        </div>
                    </InplaceContent>
                </Inplace>
            </div>
            </>
        );
    }

    getCreativeTimeColumn(rowData, prop) {
        const { activeFieldsModel } = this.state;
        const { rowIndex } = prop;
        const { column } = prop;
        const columnIndex = column.props.columnIndex;

        rowData.event.creativeTime = rowData.event.creativeTime ? moment(rowData.event.creativeTime).toDate() : null;

        let formattedUserTime = '';
        const isCreativeTimeNotReported = !rowData.event.creativeTime || rowData.event?.creativeTime === 0;
       
        formattedUserTime = isCreativeTimeNotReported  ? '00:00' : moment(rowData.event.creativeTime).format('HH:mm');
        

        const isDisabled =rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL;
        return (
            isDisabled ?
            <td style={{
                backgroundColor: 'inherit',
                color:'#5d5e5e'
            }}>
                <span style={{
                    visibility: isCreativeTimeNotReported ? 'initial' : 'initial'
                }}>
                    {formattedUserTime}
                </span>
            </td>
            :
            <div id='creative-time'>
                <Inplace
                    active={this.getIsActive(rowIndex, columnIndex, activeFieldsModel)}
                    onToggle={(e) => {
                        this.onToggleFunction(rowIndex, columnIndex, activeFieldsModel)
                    }}
                >
                    <InplaceDisplay >
                        <td style={{
                            backgroundColor: 'inherit',
                        }}>
                            <span style={{
                                visibility: isCreativeTimeNotReported ? 'initial' : 'initial'
                            }}>
                                {formattedUserTime}
                            </span>
                        </td>
                    </InplaceDisplay>
                    <InplaceContent>
                        <div style={{ display: 'flex', justifyContent: 'start', padding: 0, width: '65px', maxWidth: '65px' }}>
                            {(
                                <InputCalendarComponent
                                    id={`creativeTime-content-${rowIndex}`}
                                    name={'creativeTime'}
                                    value={rowData.event.creativeTime}
                                    stateField={`list[${rowIndex}].event`}
                                    onChange={this.handleChange}
                                    viewMode={'NEW'}
                                    showLabel={false}
                                    insideTable
                                    showTime
                                    validator={this.rowValidator}
                                    validators={`creative_time_validation:${rowIndex}`
                                    }
                                    label={t('userReporting.creativeTime')}
                                    dateFormatMoment='HH:mm'
                                    className='user-reporting-time-style'
                                    timeOnly
                                    validateViewMode={true}
                                    placeholder='HH:mm'
                                    showSeconds={false}
                                    showIcon={false}
                                    icon={() => <i className='clock' />}
                                    readOnlyInput={false}
                                    propCustomValue={true}
                                    mask='99:99'
                                    style={{
                                        maxWidth: '50px',
                                        width: '60px',
                                        boxSizing: 'border-box'
                                    }}
                                    showOnFocus={false}
                                    customTimePicker={(e) => {
                                    }}
                                    onInputClick={(id) => {
                                            const input = document.getElementById(id)
                                            input.focus();
                                            input.setSelectionRange(0, 0);
                                    }}
                                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                />
                            )}
                        </div>
                    </InplaceContent>
                </Inplace>
            </div>
        );
    }


    formatTime(time) {
        if (time) {
            const hours = Math.floor(time / 60);
            const mins = time % 60;
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }

    isRowActive(rowIndex) {
        const data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex && data[[arr[0], arr[1]]]) { //jesli dla danej kolumny jest ustawione true
                return true;
            }
        }
        return false;
    }

    closeOpenInplaceComponents(data, rowIndex) {
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
    }


    showConfirmDeleteActivityDialog(rowData, rowIndex) {
        this.setState({
            showConfirmDeleteActivityDialog: true,
            rowData: rowData,
            rowIndex: rowIndex
        })
    }

    handleDeleteActivity() {
        const { rowData } = this.state;
        const { rowIndex } = this.state;
        let data = this.state.activeFieldsModel.map;
        this.closeOpenInplaceComponents(data, rowIndex);

        this.setState(
            {
                loading: true,
            },
            () => {
                const setStateElement = {
                    loading: false,
                    showConfirmDeleteActivityDialog: false,
                    rowData: undefined,
                    rowIndex: undefined,
                    activeFieldsModel: {
                        map: data
                    }
                };
                this.dayViewService
                    .delete(rowData.event.id)
                    .then((x) => {
                        if (this._isMounted) {
                            this.setState(
                                setStateElement,
                                () => {
                                    this.refreshTable();
                                }
                            );
                        }
                    }).catch((err) => {
                        if (this._isMounted) {
                            this.showErrorMessage(err.message);
                            this.setState(
                                {
                                    loading: false,
                                    showConfirmDeleteActivityDialog: false,
                                    rowData: undefined,
                                    rowIndex: undefined,
                                },
                                () => {
                                    this.refreshTable();
                                }
                            );
                        }
                    })
            }
        );
    }

    getClosedInplaceComponentsMapForRow(rowIndex) {
        let data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
        return data;
    }

    cancelRowEdit(rowIndex) {
        const data = this.getClosedInplaceComponentsMapForRow(rowIndex);
        this.setState({
            activeFieldsModel: {
                map: data
            }
        })
    }

    getActionsColumn(rowData, prop) {
        const { rowIndex } = prop;
        const isRowActive = this.isRowActive(rowIndex);
        const isEventApproved = rowData.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL || rowData.event.acceptLevel === Constants.PM_APPROVED_LEVEL
        return (
            <div style={{ display: 'flex', justifyContent: 'start', maxWidth: '60px', marginLeft: '10px' }}>
                {isRowActive ? (
                    <>
                        <ActionLink
                            iconName='pi pi-check'
                            iconPrefix='pi'
                            iconSide='left'
                            id='edit-button'
                            iconSize='icon-medium'
                            rendered={true}
                            color='black'
                            handleClick={(e) => {
                                this.handleEditActivity(rowData, rowIndex)
                            }}
                            className='edit-blue-link'
                            key={'delete-button'}
                        />
                        <ActionLink
                            iconName='mdi mdi-cancel'
                            iconSize='icon-medium'
                            rendered={true}
                            handleClick={(e) => {
                                this.cancelRowEdit(rowIndex)
                                this.refreshTable()
                            }}
                            color='black'
                            classN
                            ame='edit-blue-link'
                            key={'delete-button'}
                        />

                    </>
                ) : <ActionLink
                    iconName='mdi mdi-delete'
                    iconSize='icon-medium'
                    rendered={!isEventApproved}
                    handleClick={(e) => {
                        this.showConfirmDeleteActivityDialog(rowData, rowIndex)
                    }}
                    color='black'
                    classN
                    ame='edit-blue-link'
                    key={'delete-button'}
                />}
            </div>
        )
    }
    
    isCreativeTimeColumnRequired() {
        const isStartEndNotRequired = !this.isStartEndDateRequired(); //tylko dla opcji z wpisywaniem ilości godzin
        const userHasPernamentContract = this.state.contractTypeForDay === 'PERNAMENT'; //i tylko kiedy user ma umowe o prace na dany dzień
        return this.authService.getProfile().featureCreativeWorkReportingEnabled === true && isStartEndNotRequired && userHasPernamentContract
    }

    prepareColumns() {
        const startEndRequired = this.isStartEndDateRequired();
        const creativeTimeColumnRequired = this.isCreativeTimeColumnRequired()

        let columns = [
            {
                field: 'client.name',
                header: t('userReporting.client'),
                body: this.getClientColumn.bind(this),
                width: '150px'
            },
            {
                field: 'project.name',
                header: t('userReporting.project'),
                body: this.getProjectColumn.bind(this),
            },
            {
                field: 'activity.name',
                header: t('userReporting.activity'),
                body: this.getActivityColumn.bind(this),

            },
            {
                field: 'comment',
                header: t('userReporting.comment'),
                body: this.getCommentColumn.bind(this),
                footer: this.getCommentColumn.bind(this),
                height: '100%'
            },
            {
                field: 'userTime',
                header: startEndRequired ? t('userReporting.hours') : t('userReporting.workTime'),
                body: this.getUserTimeColumn.bind(this),
                width: startEndRequired && !creativeTimeColumnRequired  ? '140px' : '65px'
            },
        ];

        if(creativeTimeColumnRequired){
            columns.push({
                field: 'creativeTime',
                header: 'Praca twórcza',
                body: this.getCreativeTimeColumn.bind(this),
                width: '65px'
            });
        }

        columns.push({
            field:'',
            header: '',
            body: this.getActionsColumn.bind(this),
            width: '120px'
        });

        return columns;
    }

    afterObjectUpdate() {
        this.readMessage();
        this.refreshTable();
        this.unblockUi();
    }

    getFormattedDay(date) {
        const day = moment(date ? date : new Date()).date();
        const weekDay = moment(date ? date : new Date()).weekday();
        const month = moment(date ? date : new Date()).month();

        const formattedWeekDay = t(`weekDays.${weekDay}`);
        let monthFormattedStr = t(`monthsDeclination.${month}`);
        return (
            <span>
                {`${formattedWeekDay} ${day} ${monthFormattedStr}`}
            </span>
        );
    }

    decreaseSelectedDay() {
        const { criteria } = this.state;
        let newDate = criteria.selectedDay.subtract(1, 'day');


        const paramDate = moment(newDate).format(Constants.DATE_JSON_FORMAT)
        const url = `/#/day-view?day=${paramDate}`
        window.location.href = url;

        this.setState(
            (prevState) => ({
                criteria: {
                    ...prevState.criteria,
                    selectedDay: newDate,
                },
                userDay: {}
            }
            ), this.refreshTable
        )
    }
    increaseSelectedDay() {
        const { criteria } = this.state;
        let newDate = criteria.selectedDay.add(1, 'day');

        const paramDate = moment(newDate).format(Constants.DATE_JSON_FORMAT)
        const url = `/#/day-view?day=${paramDate}`
        window.location.href = url;

        this.setState(
            (prevState) => ({
                criteria: {
                    ...prevState.criteria,
                    selectedDay: newDate,
                },
                userDay: {}
            }
            ), this.refreshTable
        )
    }

    renderHeaderDetails() {
        const { criteria } = this.state;
        return (
            <div style={{
                display:'flex',
                justifyContent: 'start'
            }}>
                <i id='left' className="timelineHeaderIcon mdi mdi-chevron-left icon-large-plus " style={{ marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px' }}
                    onClick={() => {
                        if (this.isDirty()) { //wywal komunikat jesli dirty
                            this.setState({
                                dialogVisibile: true
                            })
                        } else { //else idz do przodu
                            this.decreaseSelectedDay()
                        }
                    }}
                />
                <i id='right' className="timelineHeaderIcon mdi mdi-chevron-right icon-large-plus " style={{ marginRight: '14px', color: '#9d9d9e', cursor: 'pointer', fontSize: '40px' }}
                    onClick={() => {
                        if (this.isDirty()) { //wywal komunikat jesli dirty
                            this.setState({
                                dialogVisibile: true
                            })
                        } else { //else idz do przodu
                            this.increaseSelectedDay()
                        }
                    }}
                />
                <span style={{
                    fontSize: '30px',
                    paddingTop: '17px'
                }}>
                   {this.getFormattedDay(criteria.selectedDay)}
                </span>
            </div>
        );
    }

    getConfirmDeleteActivityDialog() {
        return (
            <YesNoDialog
                visible={this.state.showConfirmDeleteActivityDialog}
                header={t('userReporting.confirmDeleteHeader')}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        this.handleDeleteActivity();
                    } else {
                        this.setState({ showConfirmDeleteActivityDialog: false })
                    }
                }}
                onHide={() => this.setState({ showConfirmDeleteActivityDialog: false })}
            >
                {t('userReporting.day.confirmDeleteMessage')}
            </YesNoDialog>
        );
    }

    handleApprove() {
        const userDayId = this.state.list.map(x=>x.event.userDayId)[0]
        this.service
            .approve(userDayId)
            .then((x) => this.refreshTable())
            .catch((err) => {
                this.showErrorMessage(err.message);
            })
    }
    handleUnlockReportedDay() {
        const userDayId = this.state.list.map(x=>x.event.userDayId)[0]
        this.service
            .open(userDayId)
            .then((x) => this.refreshTable())
            .catch((err) => {
                this.showErrorMessage(err.message);
            })
    }

    getApproveReportedDayDialog() {
        return (
            <YesNoDialog
                visible={this.state.approveDialogVisible}
                header={t('userReporting.approve')}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        this.handleApprove();
                        this.setState({ approveDialogVisible: false })
                    } else {
                        this.setState({ approveDialogVisible: false })
                    }
                }}
                onHide={() => this.setState({ approveDialogVisible: false })}
            >
                {t('userReporting.day.confirmMessage')}
                </YesNoDialog>
        );
    }

    getUnlockReportedDayDialog() {
        return (
            <YesNoDialog
                visible={this.state.unlockDialogVisible}
                header={t('userReporting.unlockHeaderDay')}
                name='visible'
                onChange={(type, x, target) => {
                    if (target.value) {
                        this.handleUnlockReportedDay();
                        this.setState({ unlockDialogVisible: false })
                    } else {
                        this.setState({ unlockDialogVisible: false })
                    }
                }}
                onHide={() => this.setState({ unlockDialogVisible: false })}
            >
                {t('userReporting.day.unblockMessage')}
            </YesNoDialog>
        );
    }
    renderView() {
        const renderHeader = this.props.renderHeader === undefined || this.props.renderHeader === true;
        const userDayId = this.state.list.length > 0 ? this.state.list.map(x => x.event.userDayId)[0] : this.state.userDayId;

        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <div style={{ minHeight: "900px" }}>

                        <Card
                            className='list-card'
                        >    <UserRedirectWarningDialog
                            visible={this.state.dialogVisibile}
                            onHide={(e) => this.setState({ dialogVisibile: false })}
                        >
                                <span>{t('userReporting.userRedirectWarning')}</span>
                            </UserRedirectWarningDialog>
                            {this.getApproveReportedDayDialog()}
                            {this.getUnlockReportedDayDialog()}
                            {this.getConfirmDeleteActivityDialog()}
                            <DivContainer colClass='row' rendered={this.props.hideFilters !== true}>
                                {this.renderHeaderDetails()}
                            </DivContainer>
                            <DivContainer colClass='row' rendered={renderHeader}>{this.renderHeader()}</DivContainer>
                            <TabView
                                activeIndex={this.state.activeIndex}
                                onTabChange={(e) => {
                                    if (!this.isDirty()) {
                                        this.setState({ activeIndex: e.index }, () => {
                                            this.props.history.push({
                                                search: this.createQueryString({ activeIndex: e.index }),
                                            });
                                        });
                                    }else{
                                        this.setState({
                                            dialogVisibile: true
                                        })
                                    }
                                }}
                            >
                                <TabPanel header='Aktywności'>
                                    {this.renderDataTable(this.prepareColumns())}
                                </TabPanel>
                                {this.authService.isUserInAnyRole('ROLE_EVENT_LOG_LIST_VIEW', 'ROLE_REPORT_OWN_TIME') ?
                                    <TabPanel header='Dziennik zdarzeń'>
                                        {userDayId ?
                                            <LogEntryListContainer
                                                objectType='USER_DAY'
                                                objectId={`${userDayId}`}
                                                expandFilters={false}
                                                renderHeader={false}
                                            />
                                            : null}
                                        {!userDayId ?
                                            <LogEntryListContainer
                                                objectType='USER_DAY'
                                                noRefresh={true} //nie powinno byc requesta kiedy nie ma user day na dzien
                                                expandFilters={false}
                                                renderHeader={false}
                                            />
                                            : null}
                                    </TabPanel>
                                    :
                                    null
                                }
                            </TabView>
                        </Card>
                        {this.state.downloadingPdf && <PdfDownloadSpinner />}
                    </div>

                </BlockUi>
            </DivContainer>
        );
    }


    render() {
        return (
            <div className='container-fluid projectcategory-list'>
                <BreadcrumbsItem to='/email-list'>{''}</BreadcrumbsItem>
                <Prompt
                    when={this.isDirty()} //true jesli przynajmniej jedno pole jest edytowane
                    message={(location) => { //kiedy user chce przejsc na innna zakladke w apce i isDirty true 
                    //-> wyswietlenie dialogu
                        this.setState({
                            dialogVisibile: true
                        })
                        return false; //-> zablokowanie przejscia
                    }}
                ></Prompt>
                {this.renderView()}
            </div>
        );
    }
}

DayViewContainer.defaultProps = {
    lazy: true,
    renderHeader: true,
};

DayViewContainer.propTypes = {
};

export default DayViewContainer;